// packages/app/src/scaffolder/selectFieldFromApiModule.ts
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint, createFormField } from '@backstage/plugin-scaffolder-react/alpha';
import { SelectFieldFromApi } from './components/scaffolder-frontend-module-http-request-field/src';
import { AzureDevOpsBranchFieldExtension, AzureDevOpsTokenFieldExtension, AzureDevOpsProjectFieldExtension, AzureDevOpsRepoFieldExtension } from '@internal/backstage-plugin-scaffolder-backend-module-azure-devops/frontend';
import { AdoPipelineAccessFieldExtension, ApiDataLoaderFieldExtension, ArraySelectorFieldExtension, DataSelectorFieldExtension, EntraOAuthTokenFieldExtension } from 'backstage-plugin-simcorp';

export const scaffolderCustomizations = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormFieldBlueprint.make({
      name: 'SelectFieldFromApi',
      params: {
        field: async () =>
          createFormField({
            name: 'SelectFieldFromApi',
            component: SelectFieldFromApi,
          }),
      },
    }),
    AzureDevOpsTokenFieldExtension,
    AzureDevOpsBranchFieldExtension,
    AzureDevOpsRepoFieldExtension,
    AzureDevOpsProjectFieldExtension,
    AdoPipelineAccessFieldExtension,
    ApiDataLoaderFieldExtension,
    ArraySelectorFieldExtension,
    DataSelectorFieldExtension,
    EntraOAuthTokenFieldExtension,
  ],
});
